.card {
  background: var(--surface);
  /* На чёрном фоне тень не читается: форму карточки задаёт светлая
     обводка. В светлой теме токен был прозрачным, и работала тень. */
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow);
  overflow: hidden;
}

.padded {
  padding: var(--pad);
}

.caption {
  margin: 24px 4px 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--muted);
}

.note {
  margin: 8px 4px 0;
  font-size: 13px;
  color: var(--muted);
}

/* Заголовок группы, ведущий к подробностям. Кнопка, а не div с onClick:
   так он доступен с клавиатуры и читается вспомогательными технологиями. */
.header {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 24px 0 8px;
  padding: 0 4px;
  background: none;
  border: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.header .caption {
  margin: 0;
}

.headerChevron {
  color: var(--muted);
  transform: translateY(1px);
}
